import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.45 3.75H20.95V10.25M14.45 10.25L20.1765 4.52344M10.95 13.75L5.22339 19.4766M4.44995 13.75V20.25H10.95",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "square"
	})]
});
export default SvgExpand;
